import type { NoteCardData } from './types';
import { previewText } from './preview-text';

/**
 * Read-only note result card. Shows the title + a clamped body preview.
 * The whole card is clickable → onOpen() (opens the note in Drive).
 * Mirrors EmailResultCard chrome (rc-card / rc-meta).
 */
export function NoteResultCard({ data, onOpen }: { data: NoteCardData; onOpen: () => void }) {
  const { title } = data;
  const preview = previewText(data.bodyPreview);

  return (
    <button type="button" className="rc-card rc-note" onClick={onOpen}>
      <div className="rc-meta">
        <span className="rc-meta-kind">📝 NOTE</span>
      </div>

      <div className="rc-subject">{title || 'Untitled note'}</div>
      {preview && <div className="rc-note-preview">{preview}</div>}
    </button>
  );
}
